import { KEY_CODES } from '../util';

class Modals {
  constructor() {
    this.modals = document.querySelectorAll('.js--modal');
    this.modalOpeners = document.querySelectorAll('.js--modal-open');
    this.modalClosers = document.querySelectorAll('.js--modal-close');
    this.body = document.querySelector('body');

    this.bindEvents();
  }

  bindEvents() {
    const openers = Array.from(this.modalOpeners);
    const closers = Array.from(this.modalClosers);
    openers.forEach(btn => btn.addEventListener('click', e => this.toggleModal(e)));
    closers.forEach(btn => btn.addEventListener('click', () => this.close()));
  }

  toggleModal(e) {
    // Set the current modal
    this.currentModal = e.currentTarget.nextElementSibling;
    // Set the current container
    this.currentModalContainer = e.currentTarget.closest('.js--modal-container');

    const isModalHidden = this.currentModal.classList.contains('is-hidden');

    if (isModalHidden) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.currentModal.removeAttribute('aria-hidden');
    this.currentModal.classList.remove('is-hidden');
    this.currentModalContainer.classList.add('is-on-top');
    this.body.classList.add('inactive');

    // Set the current close button
    this.closeButton = this.currentModal.querySelector('.js--modal-content .js--modal-close');

    // Set focusable elements
    this.focusableEls = [
      ...Array.from(this.currentModal.querySelectorAll('a')),
      ...Array.from(this.currentModal.querySelectorAll('iframe')),
      this.closeButton,
    ];
    this.firstFocusableEl = this.focusableEls[0];
    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];

    document.addEventListener('keydown', e => this.keydown(e));
  }

  close() {
    this.currentModal.setAttribute('aria-hidden', true);
    this.currentModal.classList.add('is-hidden');
    this.currentModalContainer.classList.remove('is-on-top');
    this.body.classList.remove('inactive');

    document.removeEventListener('keydown', e => this.keydown(e));
  }

  handleBackwardTab(e) {
    if (document.activeElement === this.firstFocusableEl) {
      e.preventDefault();
      this.lastFocusableEl.focus();
    }
  }

  handleForwardTab(e) {
    if (document.activeElement === this.lastFocusableEl) {
      e.preventDefault();
      this.firstFocusableEl.focus();
    }
  }

  keydown(e) {
    switch (e.key) {
      case KEY_CODES.ESCAPE:
      case KEY_CODES.ESCAPE_IE11:
        this.close();
        break;

      case KEY_CODES.TAB:
        if (this.focusableEls.length === 1) {
          e.preventDefault();
          break;
        }
        if (e.shiftKey) {
          this.handleBackwardTab(e);
        } else {
          this.handleForwardTab(e);
        }
        break;

      default:
        break;
    }
  }
}

export default Modals;
